export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10782.e588690e.jpg";